import { ModuleHubLayout } from "../../components/shell/ModuleHubLayout";
import { filterAdminNavSections } from "../../config/navigation";
import { useAuth } from "../../stores/auth";

export function AdminConfigLayout() {
  const { can, moduleEnabled } = useAuth();
  const sections = filterAdminNavSections(can, moduleEnabled);

  return (
    <ModuleHubLayout
      title="Admin Configuration"
      subtitle="Settings, access, and audit"
      sections={sections}
    />
  );
}
